import {
	cookie_setParticipantsNum,
	cookie_setParticipantsAges,
} from "@/logic/cookies";
import { setHash } from "@/utils/utils";
import searchPrestationsForFilter from "@/vue/planning/logic/searchPrestationsForFilter";

export default {
	setParticipants: async (storeObj, newArray) => {
		const { commit, state, dispatch } = storeObj;

		// set cookies
		cookie_setParticipantsNum(newArray.length);
		cookie_setParticipantsAges(newArray);

		const currentParticipants = [...state.participants];

		// set state
		commit("setParticipants", newArray);
		dispatch("setParticipantsDropdownOpen", false); // close dropdown

		// reset selected prestations
		commit("clearSelectedPrestIds");

		if (JSON.stringify(newArray) === JSON.stringify(currentParticipants))
			return; // ignore if same
		await searchPrestationsForFilter(storeObj); // search, and it will automatically refresh data on finish
	},

	setPackage: async (storeObj, newPackCode) => {
		const { commit, dispatch } = storeObj;

		// set hash
		setHash({ packCode: newPackCode });

		// set state
		commit("setPackage", newPackCode);
		dispatch("setPackagesMobileDropdownOpen", false); // close dropdown

		// reset selected prestations
		commit("clearSelectedPrestIds");

		await searchPrestationsForFilter(storeObj); // search, and it will automatically refresh data on finish
		dispatch("refreshDataStoredOnWindow"); // refresh data, do not search
	},

	setPackageId: (storeObj, packageId) => {
		const { commit, dispatch } = storeObj;
	},

	setDates: async (storeObj, datesObj) => {
		const { commit, state, dispatch } = storeObj;
		const startDate = datesObj["BeginDate"] || "";
		const endDate = datesObj["EndDate"] || "";

		const currentDates = { ...state.dates };

		// set hash
		const obj = {};
		if (startDate) obj["BeginDate"] = startDate;
		if (endDate) obj["EndDate"] = endDate;
		setHash(obj);

		// set state
		if (startDate) commit("setStartDate", startDate);
		if (endDate) commit("setEndDate", endDate);

		dispatch("setDatepickerOpen", ""); // close dropdown

		// reset selected prestations
		commit("clearSelectedPrestIds");

		if (JSON.stringify(datesObj) === JSON.stringify(currentDates)) return; // ignore if same
		await searchPrestationsForFilter(storeObj); // search, and it will automatically refresh data on finish
	},
};
